module.exports = __webpack_public_path__ + "static/media/google_drive.0f9115fc.svg";